import ShortcutButton from "./ShortcutButton";

export default function MessageShortcuts({
  assistantChatConfiguration,
  style,
  handleShortcutClick,
  assistantId,
}: any) {
  const redirectToWhatsapp = (phone: string) => {
    window.open(`https://api.whatsapp.com/send?phone=${phone}`, "_blank");
  };

  return (
    <div className="shortcut-buttons">
      {assistantChatConfiguration.shortcutButtons.map(
        (sbutton: any, index: number) => (
          <ShortcutButton
            key={index}
            index={index}
            assistantChatConfiguration={assistantChatConfiguration}
            userMessage={sbutton.userMessage}
            label={sbutton.label}
            style={style}
            handleShortcutClick={handleShortcutClick}
            assistantId={assistantId}
          />
        )
      )}
      {assistantChatConfiguration?.phoneNumber && (
        <ShortcutButton
          assistantChatConfiguration={assistantChatConfiguration}
          isWhatsapp={true}
          style={style}
          handleShortcutClick={redirectToWhatsapp}
          assistantId={assistantId}
        />
      )}
    </div>
  );
}
